const roboto = 'Roboto, Helvetica, Arial, sans-serif';
const barlowCondensed = `"Barlow Condensed", ${roboto}`;
const light = 300;
const regular = 400;
const medium = 500;
const bold = 700;

export default ({ palette }) => ({
  branches: {
    bodyCopy: {
      color: palette.branches.color,
      fontFamily: roboto,
      fontWeight: regular,
    },
    errorBodyCopy: {
      color: palette.branches.errorBodyCopy.color,
      fontFamily: roboto,
      fontSize: 18,
      fontWeight: regular,
    },
    errorHeader: {
      color: palette.branches.errorHeader.color,
      fontFamily: barlowCondensed,
      fontSize: 36,
      fontWeight: regular,
    },
    errorLink: {
      color: palette.branches.errorLink.color,
    },
    errorSubHeader: {
      color: palette.branches.errorSubHeader.color,
      fontFamily: roboto,
      fontSize: 18,
      fontWeight: bold,
    },
    fontFamilies: {
      primary: roboto,
      secondary: barlowCondensed,
      urls: [],
    },
    header: {
      color: palette.branches.header.color,
      fontFamily: roboto,
      fontSize: 16,
      fontWeight: regular,
    },
    heroDescription: {
      color: palette.branches.heroDescription.color,
      fontFamily: roboto,
      fontSize: 12,
      fontWeight: medium,
    },
    heroValue: {
      color: palette.branches.heroValue.color,
      fontFamily: roboto,
      fontSize: 30,
      fontWeight: regular,
    },
    productHeader: {
      color: palette.branches.productHeader.color,
      fontFamily: roboto,
      fontSize: 16,
      fontWeight: regular,
    },
    subCategory: {
      color: palette.branches.subCategory.color,
      fontFamily: roboto,
      fontSize: 18,
      fontWeight: medium,
    },
  },
  fontFamilies: {
    primary: barlowCondensed,
    secondary: roboto,
    urls: [],
  },
  fontWeights: {
    bold,
    light,
    medium,
    regular,
  },
  h1: {
    color: palette.text,
    fontFamily: barlowCondensed,
    fontSize: 24,
    fontWeight: medium,
  },
  h2: {
    color: palette.text,
    fontFamily: roboto,
    fontSize: 18,
    fontWeight: bold,
  },
  h3: {
    color: palette.text,
    fontFamily: roboto,
    fontSize: 16,
    fontWeight: bold,
  },
  h4: {
    color: palette.text,
    fontFamily: barlowCondensed,
    fontSize: 36,
    fontWeight: medium,
  },
  p: {
    fontFamily: roboto,
  },
  p1: {
    color: palette.text,
    desktopFontSize: 18,
    fontSize: 16,
    fontWeight: regular,
    lineHeight: '24px',
  },
  p2: {
    color: palette.text,
    fontSize: 16,
    fontWeight: regular,
    lineHeight: '22px',
  },
  p3: {
    color: palette.text,
    fontSize: 14,
    fontWeight: regular,
    lineHeight: '18px',
  },
  progress: {
    color: palette.primary,
    fontFamily: barlowCondensed,
    fontSize: 14,
    fontWeight: medium,
  },
  text: {}, // needed to use the branding tool since @glu/accordion-react expects ash theme
});
